export default "__VITE_ASSET__DEkHz8mF__"